import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../config/authAxios";

const initialState = {
  status: null,
  loading: false,
  data: null,
  error: "",
  message: "",
};

export const getSingleUserOfferAttemptAction = createAsyncThunk(
  "get-single-user-offer-attempt",
  async (data, { rejectWithValue }) => {
    try {
      const { attemptId } = data;
      const res = await axios.get(`/admins/api/getSingleUserOfferAttempt`, {
        params: { attemptId }
      });
      return res?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getSingleUserOfferAttemptSlice = createSlice({
  name: "get-single-user-offer-attempt",
  initialState,
  reducers: {
    resetGetSingleUserOfferAttemptState: (state) => {
      state.status = null;
      state.loading = false;
      state.data = null;
      state.error = "";
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSingleUserOfferAttemptAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSingleUserOfferAttemptAction.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action?.payload?.data;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
    builder.addCase(getSingleUserOfferAttemptAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
  },
});

export const { resetGetSingleUserOfferAttemptState } = getSingleUserOfferAttemptSlice.actions;
export const getSingleUserOfferAttemptReducer = getSingleUserOfferAttemptSlice.reducer;
